import useIsWidthLessThanBreakpoint from 'shared/hooks/app/useIsWidthLessThanBreakpoint';
import { ListingSection } from 'listing-details/types';
import { ADS_MOBILE_BREAKPOINT } from 'listing-details/constants';
import { getAdUnitCode } from './ListingDetailsPage.helpers';
import {
    AD_UNIT_PAGE,
    AD_UNIT_ROOTS,
    AD_UNIT_SECTION,
    DFP_AD_UNIT
} from '../../../shared/components/Adverts/types';

export const useAdUnitCode = (
    section: ListingSection
): DFP_AD_UNIT | [AD_UNIT_ROOTS, AD_UNIT_SECTION, AD_UNIT_PAGE] => {
    const [isMobileAd] = useIsWidthLessThanBreakpoint([ADS_MOBILE_BREAKPOINT]);

    return getAdUnitCode(isMobileAd, section);
};
